import { STATUS } from "@/config/progress";
import { Status } from "@/schema/app/assessment/status";
import ButtonGroup from "@/src/app/(auth)/assessment/_components/Header/ButtonGroup";
import HistoryText from "@/src/app/(auth)/assessment/_components/Header/HistoryText";
import { differenceInDays, format } from "date-fns";
import { useTranslation } from "react-i18next";

interface HeaderProps {
  id: number;
  status: Status;
  expiredAt: Date;
  submittedAt?: Date | null;
  isAllAnswered: boolean;
  hasImprovementProposal: boolean;
  hasFirstReport: boolean;
  hasSecondReport: boolean;
}

function Header({
  id,
  status,
  expiredAt,
  submittedAt,
  isAllAnswered,
  hasImprovementProposal,
  hasFirstReport,
  hasSecondReport,
}: HeaderProps) {
  const { t } = useTranslation();
  return (
    <div className="flex w-full items-center justify-between gap-4">
      {/* my-heading */}
      <div className="flex-col items-start justify-start gap-2">
        <div className="text-2xl font-bold text-gray-700">
          {t("your-assessment-progress")}
        </div>
        <div className="inline-flex gap-5">
          <div>
            <span className="text-gray-700">{t("status")}: </span>
            <span className="font-semibold text-gray-700">{status.name}</span>
          </div>
          <div>
            <span className="text-gray-700">
              {submittedAt ? t("submissionDate") : t("deadlineForCompletion")}:
            </span>
            <span className="font-semibold text-gray-700">
              {submittedAt
                ? `${format(submittedAt, t("date-format"))}`
                : `${differenceInDays(expiredAt, new Date())} ${t("days")}`}
            </span>
          </div>
        </div>
        <HistoryText isShow={status.id >= STATUS.SUBMITTED} />
      </div>
      <ButtonGroup
        id={id}
        hasFirstReport={hasFirstReport}
        hasSecondReport={hasSecondReport}
        hasImprovementProposal={hasImprovementProposal}
        status={status}
        isAllAnswered={isAllAnswered}
      />
    </div>
  );
}

export default Header;
